import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FilterSelectItemComponent } from '@epicuro-next/ataraxia/filter-select';
import { Filter } from '@epicuro-next/models/filters';
import { map, Observable } from 'rxjs';

import { isAccountFilter } from '../../shared';
import { OrdersFiltersStore } from '../../store/order-filters-store/order-filters.store';

@Component({
  selector: 'epc-account-filter-container',
  imports: [CommonModule, FilterSelectItemComponent],
  template: `@if (accountFilter$ | async; as accountFilter) {
    <atx-filter-select-item
      [filterItem]="accountFilter"
      [activeValues]="activeValues$ | async"
      (toggleFilter)="onToggleFilter(accountFilter, $event ?? [])"
      dropdownButtonClass="btn-light"
    ></atx-filter-select-item>
    }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountFilterContainerComponent {
  private filtersStore = inject(OrdersFiltersStore);

  public readonly accountFilter$ = this.filtersStore.accountFilter$;
  public readonly activeValues$: Observable<string[]> =
    this.filtersStore.activeFilters$.pipe(
      map(
        (selectedFilters) =>
          selectedFilters.find(isAccountFilter)?.values ?? [],
      ),
    );

  public onToggleFilter(filter: Filter, values: string[]) {
    this.filtersStore.updateActiveFilters(filter.id, values);
  }
}
